"use strict";

function deferredPromise() {
  var _resolve;
  var _reject;
  var isCancelled = false;
  var promise = new Promise(function (res, rej) {
    _resolve = res;
    _reject = rej;
  });
  promise.cancel = function () {
    isCancelled = true;
  };
  return {
    promise: promise,
    resolve: function resolve(val) {
      if (!isCancelled) {
        _resolve(val);
      }
    },
    reject: function reject(err) {
      if (!isCancelled) {
        _reject(err);
      }
    }
  };
}
module.exports = deferredPromise;
//# sourceMappingURL=deferredPromise.js.map